import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useDispatch } from 'react-redux';

import { authorizeToSlack } from '../../redux/actions/IntegrationActions';
import history from '../../routing/history';
import urls from '../../routing/urls';

import styles from './SlackRedirect.module.scss';

const SlackRedirect = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');
    const accessDenied = query.get('error');

    if (code) {
      dispatch(authorizeToSlack(code));
    }

    if (accessDenied) {
      history.push(urls.profile);
    }
  }, []);

  return (
    <div className={styles.container}>
      <Skeleton height={50} count={3} />
    </div>
  );
};

export default SlackRedirect;
